module.exports = __webpack_public_path__ + "static/media/brush-media-1@2x.82442515.png";